import { Box } from '@mui/material';
import React from 'react';
import TechnologiesSection from '../components/TechnologiesSection';
import HeroSection from '../components/HeroSection';
import VideoSection from '../components/VideoSection';

const Home = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      <HeroSection />
      <VideoSection />
      <TechnologiesSection />
    </Box>
  )
};

export default Home;

